if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.similarProducts = document.querySelectorAll(
          '.similar-product-tab',
        );
        this.similarProductJson = document.querySelector(
          '[data-similar-products]',
        );
        if (this.similarProductJson) {
          this.similarProductJson = JSON.parse(
            this.similarProductJson.innerHTML,
          );
        }
        this.setListeners();
      }

      setListeners() {
        this.similarProducts.forEach((tab) => {
          tab.addEventListener('click', (event) => {
            this.toggleFlavours(tab);
          });
        });
      }

      toggleFlavours(currentTab) {
        if (currentTab.classList.contains('similar-product-tab-selected'))
          return;

        // Update Pricing
        const oos = currentTab.getAttribute('data-product-oos');
        const mdv_prices = document.querySelectorAll('[data-mdv-price]');
        const prices = document.querySelectorAll('[data-mdv-unit-price]');
        const price = currentTab.getAttribute('data-product-price');
        let priceFormatted = currentTab.getAttribute(
          'data-product-price-formatted',
        );
        const priceSubFormatted = currentTab.getAttribute(
          'data-product-sub-price-formatted',
        );
        const skioPlanPickerCurrent = document.querySelector(
          `skio-plan-picker[productid="${currentTab.dataset.productId}"]`,
        );
        const skioCurrentPlan =
          skioPlanPickerCurrent?.shadowRoot?.querySelector(
            '.skio-group-container--selected input.skio-group-input',
          );

        // set OOS elements
        if (oos == 'true') {
          document.querySelector('.badge--sold_out').classList.remove('hide');
          document.querySelector('.product-form__submit').disabled = true;
          document.querySelector('.product-form__submit span').innerHTML =
            'Sold out';
        } else {
          document.querySelector('.badge--sold_out').classList.add('hide');
          document.querySelector('.product-form__submit').disabled = false;
          document.querySelector('.product-form__submit span').innerHTML =
            'Add to cart';
        }

        // Override Price If Required
        if (skioCurrentPlan) {
          if (!skioCurrentPlan.hasAttribute('skio-one-time')) {
            priceFormatted = priceSubFormatted;
          }
        }

        // Set Price
        for (let i = 0; i < mdv_prices.length; i++) {
          mdv_prices[i].innerText = priceFormatted;
        }
        for (let i = 0; i < prices.length; i++) {
          prices[i].setAttribute('data-mdv-unit-price', price);
          prices[i].innerText = priceFormatted;
        }

        // Get original product
        const originalProduct =
          this.similarProductJson[Object.keys(this.similarProductJson)[0]];

        // remove current selected class
        this.similarProducts.forEach((tab) => {
          if (tab.classList.contains('similar-product-tab-selected'))
            tab.classList.remove('similar-product-tab-selected');
        });

        // apply selected class
        currentTab.classList.add('similar-product-tab-selected');

        // Update form elements
        const selectedProductId = currentTab.dataset.variantId;
        const productDetails = this.similarProductJson[selectedProductId];
        const productForm = document.getElementById(
          'ProductInfo-' + productDetails.section_id,
        );
        this.form.querySelector('[name=id]').value = selectedProductId;

        // Update image sliders [featured and thumbnail]
        const slider = document.querySelector('media-gallery');
        const features = slider.querySelectorAll('slider-component ul li');
        features.forEach((featured, index) => {
          const image = featured.querySelector('.product__media');
          image.innerHTML = productDetails.images[index];
        });
        const thumbnails = slider.querySelectorAll('.thumbnail-slider ul li');
        thumbnails.forEach((thumbnail, index) => {
          const image = thumbnail.querySelector('.thumbnail');
          const id = image.querySelector('img').id;
          image.innerHTML = productDetails.images[index];
          image.querySelector('img').id = id;
        });

        // Update title
        productForm.querySelector('.product__title').innerHTML =
          productDetails.title;
        productForm.querySelector('.product__title').style =
          'color:' + productDetails.colour + ' !important';

        // Update ingredient images
        const ingredient = document.querySelectorAll('.ingredient_img');
        ingredient.forEach((ingredient, index) => {
          const header =
            ingredient.parentElement.parentElement.querySelector('h5');
          if (index == 0) {
            ingredient.src = productDetails.ingredient_1_image;
            header.innerText = productDetails.ingredient_1;
          }
          if (index == 1) {
            ingredient.src = productDetails.ingredient_2_image;
            header.innerText = productDetails.ingredient_2;
          }
          if (index == 2) {
            ingredient.src = productDetails.ingredient_3_image;
            header.innerText = productDetails.ingredient_3;
          }
        });

        // Update description content
        const content = productForm.querySelectorAll('details');
        content.forEach((detail, index) => {
          // only apply to last sections - needs futureproofing?
          if (index > 0) {
            var section = detail.querySelector('.metafield-rich_text_field');
            if (index == 1) {
              const composition = new DOMParser().parseFromString(
                productDetails.composition,
                'text/html',
              ).firstChild;
              section.innerHTML = composition.innerText;
            }
            if (index == 2) {
              const nutritional_info = new DOMParser().parseFromString(
                productDetails.nutritional_info,
                'text/html',
              ).firstChild;
              section.innerHTML = nutritional_info.innerText;
            }
          }
        });

        // Update text content
        const productText = document.querySelectorAll(
          '.product__text__content',
        );
        productText.forEach((text, index) => {
          switch (index) {
            case 0:
              text.querySelector('p').innerHTML = productDetails.usp_1;
              break;
            case 1:
              text.querySelector('p').innerHTML = productDetails.usp_2;
              break;
            case 2:
              text.querySelector('p').innerHTML =
                productDetails.for_dog_age_size;
              break;
            case 3:
              text.querySelector('p').innerHTML = productDetails.pack_detail;
              break;
          }
        });

        // Update selling plans
        const skioPlanPickers =
          productForm.querySelectorAll('skio-plan-picker');
        skioPlanPickers.forEach((plan) => {
          const productId = parseInt(plan.getAttribute('productid'));
          if (productId == productDetails.id) {
            plan.setAttribute('style', '');
          } else {
            plan.setAttribute('style', 'display:none;');
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hide', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
  }
  update() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    if (
      window.scrollY >= rangeToShowModal &&
      !this.classList.contains('show-modal')
    ) {
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if (
      window.scrollY < rangeToShowModal &&
      this.classList.contains('show-modal')
    ) {
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);
